import React, { useEffect } from "react";
import { UPLOAD_SHEET_SETUP, UPLOAD_SHEET } from "../../../api/allApi_List";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import UploadSheets from "../forms/UploadSheetsForm";
import useUploadSheet from "../../../CustomHooks/useAxios/useUploadSheet";
import MainPageLayout from "../../../layout/MainPageLayout";

const UploadSheetPage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setFormError,
    isErrorSheetList,
    setErrorSheetList,
  } = useUploadSheet();

  useEffect(() => {
    getData(UPLOAD_SHEET_SETUP);
  }, []);

  const sendData = async (formValues, reset) => {
    // send data into form data
    const formData = new FormData();
    formData.append("sheet", formValues.sheet[0]);
    formData.append("category_id", formValues.category_id);
    formValues.files.forEach((i) => {
      formData.append("pictures", i);
    });
    executePost(formData, UPLOAD_SHEET, reset);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Upload Sheet" }}>
      {isLoaded && !error ? (
        <UploadSheets
          isSucceed={isSucceed}
          sheetSetup={data}
          loading={loading}
          sendData={sendData}
          responseData={responseData}
          isErrorSheetList={isErrorSheetList}
          setErrorSheetList={setErrorSheetList}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formErrMsg)}
          closeAction={() => setFormError(false)}
        />
      )}
    </MainPageLayout>
  );
};
export default UploadSheetPage;
